import { Box, Button, InputCheckBox, Link, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onClick: () => void
  onSubmit: () => Promise<void>
  checked: boolean
}

export const TalentPoolModal = ({ onClose, onClick, onSubmit, checked }: Props) => {
  const dataProtectionUrl = i18n.t('ats.candidates.candidate_form.data_protection.url')

  return (
    <Modal
      illustration="user-move"
      title={i18n.t('ats.candidate_details.talent_pool_modal.title')}
      description={i18n.t('ats.candidate_details.talent_pool_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" flexGrow gap="s4" alignItems="center" justifyContent="flexEnd">
          <Button onClick={onClose} type="secondary">
            {i18n.t('ats.candidate_details.talent_pool_modal.button.discard')}
          </Button>
          <Button submit>{i18n.t('ats.candidate_details.talent_pool_modal.button.save')}</Button>
        </Box>
      }
    >
      <Box gap="s12">
        <Link.Href href={dataProtectionUrl} target="_blank" rel="noopener noreferrer">
          {i18n.t('ats.candidate_details.talent_pool_modal.link')}
        </Link.Href>
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Box>
            <InputCheckBox onClick={onClick} checked={checked} />
          </Box>
          <Text.Normal>{i18n.t('ats.candidate_details.talent_pool_modal.checkbox')}</Text.Normal>
        </Box>
      </Box>
    </Modal>
  )
}
